// app/reducer/action
const TOGGLE = 'common/zippy/TOGGLE';
const CLOSE = 'common/zippy/CLOSE';
const OPEN = 'common/zippy/OPEN';

type ZippyAction = {
  type: typeof TOGGLE | typeof CLOSE | typeof OPEN;
  zippy: string;
};
export type Zippies = Record<string, boolean>;

export const toggle = (zippy: string): ZippyAction => ({ type: TOGGLE, zippy });
export const close = (zippy: string): ZippyAction => ({ type: CLOSE, zippy });
export const open = (zippy: string): ZippyAction => ({ type: OPEN, zippy });

export const getBoundToggle = (zippy: string) => (() => toggle(zippy));

// eslint-disable-next-line @typescript-eslint/default-param-last
export default (zippies: Zippies = {}, action: ZippyAction) => {
  switch (action.type) {
    case TOGGLE:
      return {
        ...zippies,
        [action.zippy]: !zippies[action.zippy],
      };
    case OPEN:
      return {
        ...zippies,
        [action.zippy]: true,
      };
    case CLOSE:
      return {
        ...zippies,
        [action.zippy]: false,
      };
    default:
      return zippies;
  }
};
